module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": "true",
      "useIcon": "true"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "zoomIn"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "poper"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('i', {
    on: {
      "click": function($event) {
        _vm.hidepop()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("请输入餐前血糖值")]), _vm._v(" "), _c('div', {
    staticClass: "input_tip"
  }, [_vm._v("有效值介于4.4~25")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "id": "typevalue"
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.savedata()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), (_vm.show_error) ? _c('div', {
    staticClass: "error_info"
  }, [_vm._v("请输入有效值")]) : _vm._e()])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "zoomIn"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show1),
      expression: "show1"
    }],
    staticClass: "poper"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('i', {
    on: {
      "click": function($event) {
        _vm.hidepop1()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("请输入餐后目标值")]), _vm._v(" "), _c('div', {
    staticClass: "input_tip"
  }, [_vm._v("有效值介于4.4~15")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "id": "typevalue1"
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.savedata1()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), (_vm.show_error1) ? _c('div', {
    staticClass: "error_info"
  }, [_vm._v("请输入有效值")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "count-wrap bluestyle"
  }, [_c('div', {
    staticClass: "count-inner"
  }, [_c('div', {
    staticClass: "count-text"
  }, [_vm._v("碳水化合物")]), _vm._v(" "), _c('countTo', {
    staticClass: "count-num",
    attrs: {
      "separator": _vm.theseparator,
      "startVal": _vm.startVal,
      "endVal": _vm.endVal,
      "duration": 2000
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "count-text"
  }, [_vm._v("克")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "chose-wrap"
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.showpop()
      }
    }
  }, [_c('div', {
    staticClass: "icon-canqian"
  }, [_vm._v("餐前血糖值")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.data_canqian))])])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showpop1()
      }
    }
  }, [_c('div', {
    staticClass: "icon-canhou"
  }, [_vm._v("餐后目标值")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right motion"
  }, [_vm._v("\r\n\t\t\t\t\t" + _vm._s(_vm.data_canhou) + "\r\n\t\t\t\t")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.selectInsulin()
      }
    }
  }, [_c('div', {
    staticClass: "icon-total"
  }, [_vm._v("一日胰岛素总用量")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.data_total))])])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.selectType()
      }
    }
  }, [_c('div', {
    staticClass: "icon-zhushe"
  }, [_vm._v("使用胰岛素类别")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right"
  }, [_vm._v("\r\n\t\t\t\t\t" + _vm._s(_vm.data_zhushe) + "\r\n\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.goresult()
      }
    }
  }, [_vm._v("计算餐前注射胰岛素")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30811afa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/carbohydrate/carboresult1.vue
// module id = 140
// module chunks = 1